<div class="d-flex flex-column gap-2">
  <label class="form-input-label" for="odataSearchBar" *ngIf="label">{{ label }}</label>
  <app-odata-typeahead-search
    [odataFunction]="memberSearchFunction"
    placeHolder="Search by name or member ID"
    i18n-placeHolder
    [disabled]="!!(selectedMember$ | async) || disabled"
    [displayValueInline]="true"
    [customItemTemplate]="lookAheadItemTemplate"
    [popperClass]="'look-ahead-popper-full-width'"
    [clearSearchTrigger]="clearSearchTrigger"
    [initialSelectedItem]="selectedMember$ | async"
    (lookAheadCleared)="setSelectedMember(null)"
    (lookAheadSelected)="setSelectedMember($event)" />
</div>

<ng-template #lookAheadItemTemplate let-member>{{ member.name }} ({{ member.id }}) </ng-template>
